import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavController } from 'ionic-angular';

import { DocrenService } from '../../services/docren-service';

@Component({
  selector: 'tree-folder',
  templateUrl: 'tree-folder.html'
})

export class TreeFolderComponent {
  @Input('nodes') nodes;
  @Input('files') files;
  @Output() previewFile = new EventEmitter();
  @Output() downloadFile = new EventEmitter();

  shownGroup: any;

  constructor(public nav: NavController, private docrenService: DocrenService) { }

  clickNode(node) {
    if (!node.component) {

      if (!this.isSelected(node) && !node.isFile) this.getSubNodes(node);

      this.shownGroup = (this.isSelected(node)) ? null : node;
      return;
    }

    this.shownGroup = null;
    this.nav.push(node.component, { node: node });
  }

  isSelected(page) {
    return this.shownGroup === page;
  }

  getIcon(node) {
    if (node.sub) {
      if (this.shownGroup === node) return 'ios-folder-open-outline';
    }
    else return 'ios-document';

    return 'ios-folder';
  }

  preview(id: any) {
    this.previewFile.emit(id);
  }

  dowloadClick(id: any) {
    this.downloadFile.emit(id);
  }

  private getSubNodes(node) {

    if (node.isSub) {
      node.sub = [];
      node.sub = this.getFiles(node);
      return;
    }

    if (node.sub.length) return;

    this.docrenService.listSubCategoriesByCategoryId(node.id).subscribe(data => {
      node.sub = this.docrenService.formatNodes((data || []), true);
      node.sub = this.getFiles(node);
    });
  }

  private getFiles(node) {
    var nodeSub = (node.sub || []);

    this.files.forEach(item => {

      if (node.isSub) {
        if (item.subCategoriaId == node.id)
          nodeSub.push({ title: item.fileOriginal, id: item.id, isFile: true });

        return;
      }

      if (!item.subCategoriaId && item.categoriaId == node.id)
        nodeSub.push({ title: item.fileOriginal, id: item.id, isFile: true });
    });

    return nodeSub;
  }
}



// WEBPACK FOOTER //
// ./src/components/tree-folder/tree-folder.ts